import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const UsersPage = lazy(() =>
  import("./pages/UsersPage").then((m) => ({ default: m.UsersPage }))
);
const DoctorsListPage = lazy(() => import("./pages/DoctorsListPage"));
const DoctorViewPage = lazy(() =>
  import("./pages/DoctorViewPage").then((m) => ({ default: m.DoctorViewPage }))
);
const DoctorNewPage = lazy(() => import("./pages/DoctorNewPage"));
const DoctorEditPage = lazy(() => import("./pages/DoctorEditPage"));
const DoctorDeactivatePage = lazy(() =>
  import("./pages/DoctorDeactivatePage").then((m) => ({ default: m.DoctorDeactivatePage }))
);
const DataImportPage = lazy(() =>
  import("./pages/DataImportPage").then((m) => ({ default: m.DataImportPage }))
);
const PatientsImportPage = lazy(() =>
  import("./pages/PatientsImportPage").then((m) => ({ default: m.PatientsImportPage }))
);
const UserViewPage = lazy(() =>
  import("./pages/UserViewPage").then((m) => ({ default: m.UserViewPage }))
);
const UserEditPage = lazy(() =>
  import("./pages/UserEditPage").then((m) => ({ default: m.UserEditPage }))
);
const ConsultationsImportPage = lazy(() =>
  import("./pages/ConsultationsImportPage").then((m) => ({ default: m.ConsultationsImportPage }))
);
const AdminPage = lazy(() =>
  import("./pages/AdminPage").then((m) => ({ default: m.AdminPage }))
);
const AuditLogPage = lazy(() =>
  import("./pages/AuditLogPage").then((m) => ({ default: m.AuditLogPage }))
);
const AuditLogDetailPage = lazy(() =>
  import("./pages/AuditLogDetailPage").then((m) => ({ default: m.AuditLogDetailPage }))
);
const InviteWizardPage = lazy(() =>
  import("./pages/InviteWizardPage").then((m) => ({ default: m.InviteWizardPage }))
);

export const adminRoutes: RouteObject[] = [
  {
    index: true,
    element: <AdminPage />,
  },
  {
    path: "users",
    element: <UsersPage />,
  },
  {
    path: "users/invite",
    element: <InviteWizardPage />,
  },
  {
    path: "users/invite/details",
    element: <InviteWizardPage />,
  },
  {
    path: "doctors",
    element: <DoctorsListPage />,
  },
  {
    path: "doctors/new",
    element: <DoctorNewPage />,
  },
  {
    path: "doctors/:id/edit",
    element: <DoctorEditPage />,
  },
  {
    path: "doctors/:id/view",
    element: <DoctorViewPage />,
  },
  {
    path: "doctors/:id/deactivate",
    element: <DoctorDeactivatePage />,
  },
  {
    path: "users/:id/view",
    element: <UserViewPage />,
  },
  {
    path: "users/:id/edit",
    element: <UserEditPage />,
  },
  {
    path: "data-import",
    element: <DataImportPage />,
  },
  {
    path: "import/patients",
    element: <PatientsImportPage />,
  },
  {
    path: "import/consultations",
    element: <ConsultationsImportPage />,
  },
  {
    path: "audit-log",
    element: <AuditLogPage />,
  },
  {
    path: "audit-log/:id",
    element: <AuditLogDetailPage />,
  },
];
